import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Files } from './pages/Files';
import { Trash } from './pages/Trash';
import { ShareView } from './pages/ShareView';
import { Settings } from './pages/Settings';
import { Admin } from './pages/Admin';
import { NotFound } from './pages/NotFound';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-text-muted">加载中...</div>;
  return user ? <>{children}</> : <Navigate to="/login" replace />;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex h-screen items-center justify-center text-text-muted">加载中...</div>;
  return user ? <Navigate to="/files" replace /> : <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/share/:code" element={<ShareView />} />
      <Route element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route path="/files" element={<Files />} />
        <Route path="/files/:folderId/*" element={<Files />} />
        <Route path="/trash" element={<Trash />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
      <Route path="/" element={<Navigate to="/files" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
